"use strict";

(function () {
  var app = new Vue({
    el: "#app",
    data: function data() {
      return {
        data: {},
        yztips: "发送验证码",
        mobile: "",
        //验证手机
        macode: "",
        //验证码
        company_name: "",
        company_bank_card: "",
        company_bank_name: "",
        is_auth: 0,
        pageshow: false,
        //上传图片
        avatar: "",
        binary: [],
        idzArr: [],
        upimg: "",
        isimg: true,
        //上传图片end
        shop_name: "",
        //店铺名称
        business: "",
        //营业执照
        is_show_shop_name: 0,
        isupimg: true,
        imgshow: false
      };
    },
    created: function created() {
      this.datas();
    },
    methods: {
      goup: function goup() {
        this.$utils.backRefresh(); //返回上页刷新
      },
      datas: function datas() {
        var _this2 = this;

        this.$utils.loading(); //开起加载

        this.$http.get("/api/user/company_auth", {
          params: {
            type: 1 //1银行卡 2支付宝

          }
        }).then(function (res) {
          _this2.$utils.loadingClear(); //关闭加载


          _this2.data = res.data;
          _this2.is_auth = res.data.is_auth;
          _this2.company_name = res.data.company_name;
          _this2.company_bank_card = res.data.company_bank_card;
          _this2.company_bank_name = res.data.company_bank_name;
          _this2.mobile = res.data.mobile;
          _this2.avatar = _this2.upimg = res.data.business || "https://img10.cqxjkc.com/h5/earch/images/four/addimg.png";
          _this2.business = res.data.business;
          _this2.shop_name = res.data.shop_name;
          _this2.is_show_shop_name = res.data.is_show_shop_name;
          _this2.pageshow = true;
        });
      },
      yz: function yz() {
        var _this3 = this;

        if (this.tel == "") {
          vant.Toast({
            message: "请输入手机号",
            position: "bottom"
          });
          return;
        } else if (this.yztips != "发送验证码") {
          return;
        }

        this.$utils.loading(); //开起加载

        this.$http.post("/api/message/verification", {
          mobile: this.mobile,
          scene: 9 //1注册 2忘记密码 8登录 9实名认证

        }).then(function (res) {
          _this3.$utils.loadingClear(); //关闭加载


          if (res.code == 0) {
            vant.Toast({
              message: "验证码已发送，请注意查收",
              position: "bottom"
            });
            var i = 59;
            var stime = setInterval(function () {
              if (i == 0) {
                clearInterval(stime);
                i = 59;
                _this3.yztips = "发送验证码";
                _this3.$refs.sends.className = "sendyz dm";
                return;
              }

              _this3.yztips = "再次获取(" + i + ")";
              _this3.$refs.sends.className = "sendyzx dm";
              i--;
            }, 1000);
          }
        });
      },
      sends: function sends() {
        var _this4 = this;

        if (this.company_name == "") {
          vant.Toast({
            message: "请输入企业名称",
            position: "bottom"
          });
          return;
        } else if (this.company_bank_card == "") {
          vant.Toast({
            message: "请输入对公账户",
            position: "bottom"
          });
          return;
        } else if (this.company_bank_name == "") {
          vant.Toast({
            message: "请输入开户支行",
            position: "bottom"
          });
          return;
        } else if (this.macode == "") {
          vant.Toast({
            message: "请输入验证码",
            position: "bottom"
          });
          return;
        } else if (this.is_show_shop_name == 1 && this.shop_name == "") {
          vant.Toast({
            message: "请输入店铺名称",
            position: "bottom"
          });
          return;
        } else if (this.isupimg) {
          vant.Toast({
            message: "请上传营业执照",
            position: "bottom"
          });
          return;
        }

        if (this.company_name == this.data.company_name && this.company_bank_card == this.data.company_bank_card && this.isupimg && this.company_bank_name == this.data.company_bank_name) {
          vant.Toast({
            message: "请先修改内容",
            position: "bottom"
          });
          return;
        }

        this.$utils.loading(); //开起加载

        var i = 0;

        if (this.upimg == "") {
          this.siurl(this.idzArr, this.binary);
        }

        var simtes = setInterval(function () {
          if (i == 60) {
            vant.Toast({
              message: "上传失败",
              position: "bottom"
            });
            i = 0;
            clearInterval(simtes);

            _this4.$utils.loadingClear(); //关闭加载


            return;
          }

          if (_this4.isimg == true) {
            i = 0;
            clearInterval(simtes); //上传

            _this4.$http.post("/api/user/to_company_auth", {
              type: 1,
              //1银行卡 2支付宝
              code: _this4.macode,
              company_name: _this4.company_name,
              company_bank_card: _this4.company_bank_card,
              company_bank_name: _this4.company_bank_name,
              shop_name: _this4.shop_name,
              business: _this4.upimg
            }).then(function (res) {
              _this4.$utils.loadingClear(); //关闭加载


              if (res.code == 0) {
                vant.Toast({
                  message: "认证成功",
                  position: "bottom"
                });
                setTimeout(function () {
                  _this4.$utils.backRefresh(); //返回上页刷新

                }, 1000);
              }
            });
          }
        }, 1000);
      },
      changephoto: function changephoto() {
        var _this5 = this;

        this.isupimg = false;
        this.isimg = false; //修改了头像 需要is_idz=true的时候才能提交

        this.upimg = ""; //修改了头像 需要上传的图片路径为空

        this.idzArr = []; //修改了头像 接口需要的 extend数组为空，因为这里只传一张，避免上传多张无用的图

        var ufile = this.$refs.ufile;

        if (ufile.value == "") {
          this.$refs.uimg.src = this.avatar;
          this.isimg = true;
          this.isupimg = true;
          this.upimg = this.$refs.uimg.src;
          return;
        }

        var fileNamest = ufile.value; //获取上传的文件（单个）

        var extNames = fileNamest.substr(fileNamest.lastIndexOf(".") + 1).toLowerCase(); //获取后缀名

        if (extNames != "png" && extNames != "jpg" && extNames != "jpeg") {
          vant.Toast({
            message: "请选择jpg、jpeg、png格式的图片",
            position: "bottom"
          });
          this.isimg = true;
          this.isupimg = true;
          this.upimg = this.$refs.uimg.src;
          return;
        }

        this.$refs.uimg.src = window.URL.createObjectURL(ufile.files[0]); //页面直接获取file中的图引入

        var fils = ufile.files[0];
        var reader = new FileReader();
        reader.readAsArrayBuffer(fils); //使用FileReader.readAsArrayBuffer将图片分割为很多节二进制数组

        reader.onload = function () {
          _this5.binary = reader.result; //图片二进制数组

          var fileName = ufile.value; //获取上传的文件（单个）

          var extName = fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase(); //获取后缀名

          _this5.idzArr.push(extName); //extend参数所需的格式josn数组

        };
      },
      siurl: function siurl(arr, binary) {
        var _this6 = this;

        var imgas = JSON.stringify(arr);
        this.$http.post("/api/upload/signUrlPut", {
          prefix: "avatar",
          extend: imgas
        }).then(function (res) {
          if (res.code == 0) {
            var content_type = res.data.sign_url[0].headers.content_type; //Content-Type 数据类型

            var url = res.data.sign_url[0].url; //xhr.open('put',		url 	)

            var imgs = url.split("?"); //图片的前端地址

            _this6.upimg = imgs[0];

            _this6.upload(content_type, url, binary);
          }
        });
      },
      upload: function upload(content_type, url, binary) {
        console.log(content_type);
        console.log(url);
        console.log(binary);

        var _this = this;

        var xhr = new XMLHttpRequest();
        xhr.open("PUT", url); //接口方式及地址

        xhr.overrideMimeType("application/octet-stream"); //避免Content-Type头不是有效的XML

        xhr.setRequestHeader("Content-Type", content_type); //默认为 "text/xml" 这里设置为”images/png“

        if (xhr.sendAsBinary) {
          xhr.sendAsBinary(binary); //以二进制方式发送
        } else {
          xhr.send(binary);
        }

        console.log(1); // 监听变化

        xhr.onreadystatechange = function (e) {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              console.log(2); // 响应成功
              //判断点击上传的时候需要is_idz和is_idf都为true的时候才能请求接口

              _this.isimg = true;
            }
          }
        };
      },
      bankisy: function bankisy() {
        if (this.blank == "") {
          vant.Toast({
            message: "请先填写开户银行",
            position: "bottom"
          });
          return;
        }

        this.show = true;
      }
    }
  });
  window.app = app;
})();